import CustomIcons from "~/components/CustomIcons";
import minifyTheme from 'minify-css-string'

export default {
  rtl: false,
  theme: {
    options: {
      customProperties: true,
      minifyTheme,
      variations: false
    },
    dark: true,
    themes: {
      light: {
          primary1: "#F1F2F6",
          primary2: "#E9ECF5",
          primary3: "#E2E6F5",
          primary4: "#E4F3FF",
          primary5: "#2A8CFD",
          primary: "#2A7BE9",
          primary6: "#2A68D7",
          primary7: "#2748B7",
          gray1: "#F8F8F6",
          gray2: "#F2F2F0",
          gray3: "#E7E7E7",
          gray4: "#DBDCDD",
          gray5: "#CCCED0",
          gray6: "#B1B2B7",
          gray7: "#93959D",
          gray8: "#7D808A",
          gray9: "#696C75",
          gray10: "#50535B",
          gray11: "#3E4148",
          gray12: "#2A2C30",
          gray13: "#21242B",
          black: "#000000",
          white: "#FFFFFF",
          fieldBg: "#FFFFFF",
          background: "#F8F8F6",
          onPrimary: "#F8F8F6",
          primaryx: "#2A7BE9",
          snackBar: "#232529",
          success: "#35BA00",
          successTransparent: "#EFF9EB",
          info: "#3889D0",
          infoTransparent: "#EFF6FB",
          warning: "#F18F01",
          warningTransparent: "#FCF2E4",
          error: "#EC484A",
          errorTransparent: "#FDF0F1"
        },
        dark: {
          primary1: "#191F2A",
          primary2: "#22262F",
          primary3: "#313642",
          primary4: "#2748B7",
          primary5: "#2A68D7",
          primary: "#00E5FD",
          primary6: "#2A8CFD",
          primary7: "#E4F3FF",
          gray1: "#21242B",
          gray2: "#2A2C30",
          gray3: "#3E4148",
          gray4: "#50535B",
          gray5: "#696C75",
          gray6: "#7D808A",
          gray7: "#93959D",
          gray8: "#B1B2B7",
          gray9: "#CCCED0",
          gray10: "#DBDCDD",
          gray11: "#E7E7E7",
          gray12: "#F2F2F0",
          gray13: "#F8F8F6",
          black: "#000000",
          white: "#FFFFFF",
          fieldBg: "#383B43",
          background: "#181B22",
          onPrimary: "#2F3736",
          primaryx: "#F8F8F6",
          snackBar: "#2A2C30",
          success: "#04B283",
          info: "#56A5E1",
          warning: "#F5B14B",
          error: "#F15057",
        },
    }
  },
  icons: {
    values: CustomIcons
  }
};
